import { version } from "@internal/package";
import { defineStore } from "@otto-ec/global-resources/nexus";
import { toggle } from "@otto-ec/global-resources/toggle";
import { waitForMount } from "@otto-ec/otto-components-utils/utils/waitForMount";
import { components } from "./common/component";
import { setColorScheme } from "./common/theme.js";
import { canUseHtmlPopoverApi } from "./common/utils/canUseHtmlPopoverApi";

/*                                                                        */
import.meta.glob(["./components/**/*.async.svelte", "!./components/**/SheetV*.async.svelte"], {
  eager: true,
});

if (
  import.meta.env.VITE_BUILD_ENVIRONMENT_TARGET === "develop" &&
  !import.meta.env.STORYBOOK &&
  toggle.get("oc_darkmode_toggle_enabled")
) {
  import("./common/components/DarkmodeToggle/DarkmodeToggle.testing.js");
}

/*                                                     */
const apis = Object.entries(
  import.meta.glob<true, string, Record<string, unknown>>(
    ["./components/**/*.api.ts", "!./components/**/SheetV1.api.ts"],
    {
      eager: true,
    },
  ),
).map(([path, module]) => {
  const name = path.match(/\/([^/]+)\.api\.ts$/)?.[1];

  if (import.meta.env.DEV && !name) {
    throw new Error(`Could not parse component name from path: ${path}`);
  }

  const key = name![0].toLowerCase() + name!.slice(1);
  const api = module[key];

  if (import.meta.env.DEV && !api) {
    throw new Error(`Module ${path} does not export ${key}`);
  }

  return { [key]: api };
});

/*                                           */
if (toggle.get("oc_sheet_as_dialog_and_center_sheet", true)) {
  /*                                                    */
  import("./components/sheet/v1/main");
} else {
  /*                                     */
  import("./components/sheet/v0/main");
}

components.assignNamespace(
  Object.assign(
    {
      version: () => version,
      setColorScheme,
      asyncComponentsLoaded: defineStore(true),
      waitForMount,
    },
    ...apis,
  ),
);
